// extracted by mini-css-extract-plugin
export default {"button":"Button_button__LJ9CQ","primary":"Button_primary__-cK-P","destructive":"Button_destructive__BWV17"};